import { createContext, useContext, useMemo } from 'react';
import { separateContexts } from '../../common/filtering';
import { DatabaseContext } from './DatabaseContext';
import { FunctionsContext } from './FunctionsContext';
import { AppContext } from './AppProvider';
import { useRenders } from './useHelpers/useRenders';


/**
 * Provider providing
  appContext
  , `databaseContext`
  , `functionContext`
 */
export const AppParentContext = createContext();

const AppParentProvider = (props) => {

  const appContext = useContext(AppContext);
  const databaseContext = useContext(DatabaseContext);
  const functionContext = useContext(FunctionsContext);

  useRenders('AppParentProvider', true)

  const contexts = {
    appContext: appContext,
    databaseContext: databaseContext,
    functionContext: functionContext,
  }

  const appParent_contexts = useMemo(() => separateContexts(contexts), [contexts]);

  return <AppParentContext.Provider value={{ ...props, ...appParent_contexts }}>
    {props.children}
  </AppParentContext.Provider>
};

export default AppParentProvider